(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["the-lane-product-ux"] && !Shopify.designMode) return;
  try {
    (function(){
var moreLabel='';
var lessLabel='';
var swipeLabel='';
function refreshLabels(){
var copy=document.getElementById('tl-product-ux-copy-v1');
if(!copy)return false;
moreLabel=copy.getAttribute('data-more')||'';
lessLabel=copy.getAttribute('data-less')||'';
swipeLabel=copy.getAttribute('data-swipe')||'';
return true;
}
function directSlides(slides){return Array.prototype.filter.call(slides.children,function(child){return child.tagName&&child.tagName.toLowerCase()==='slideshow-slide';});}
function updateGallery(gallery,expanded){
var toggle=gallery.querySelector('.tl-gallery-toggle-v1');
if(!toggle)return;
gallery.setAttribute('data-tl-gallery-expanded',expanded?'true':'false');
toggle.setAttribute('aria-expanded',expanded?'true':'false');
var label=toggle.querySelector('.tl-gallery-toggle-v1__label');
var icon=toggle.querySelector('.tl-gallery-toggle-v1__icon');
if(label)label.textContent=expanded?lessLabel:moreLabel;
if(icon)icon.textContent=expanded?'−':'+';
}
function initGalleries(){
Array.prototype.forEach.call(document.querySelectorAll('.product-information__media media-gallery'),function(gallery,index){
var slides=gallery.querySelector('slideshow-slides');
if(!slides)return;
var items=directSlides(slides);
var toggle=gallery.querySelector('.tl-gallery-toggle-v1');
if(items.length<=5){
gallery.removeAttribute('data-tl-gallery-collapsible');
gallery.removeAttribute('data-tl-gallery-expanded');
if(toggle)toggle.remove();
return;
}
gallery.setAttribute('data-tl-gallery-collapsible','true');
if(!slides.id)slides.id='tl-product-media-list-v1-'+index;
if(!toggle){
toggle=document.createElement('button');
toggle.type='button';
toggle.className='tl-gallery-toggle-v1';
toggle.setAttribute('aria-controls',slides.id);
var label=document.createElement('span');
label.className='tl-gallery-toggle-v1__label';
var icon=document.createElement('span');
icon.className='tl-gallery-toggle-v1__icon';
icon.setAttribute('aria-hidden','true');
toggle.appendChild(label);
toggle.appendChild(icon);
slides.parentNode.insertBefore(toggle,slides.nextSibling);
toggle.addEventListener('click',function(){
var wasExpanded=gallery.getAttribute('data-tl-gallery-expanded')==='true';
updateGallery(gallery,!wasExpanded);
if(wasExpanded){
window.requestAnimationFrame(function(){
toggle.scrollIntoView({behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
});
}
});
}
updateGallery(gallery,gallery.getAttribute('data-tl-gallery-expanded')==='true');
});
}
function createSwipeCue(scroll){
var cue=scroll.parentNode.querySelector('.tl-fit-swipe-cue-v1');
if(cue)return cue;
cue=document.createElement('div');
cue.className='tl-fit-swipe-cue-v1';
cue.setAttribute('role','note');
cue.setAttribute('aria-label',swipeLabel);
cue.setAttribute('data-used','false');
var graphic=document.createElement('span');
graphic.className='tl-fit-swipe-cue-v1__graphic';
graphic.setAttribute('aria-hidden','true');
var left=document.createElement('span');
left.className='tl-fit-swipe-cue-v1__arrow';
left.textContent='←';
var track=document.createElement('span');
track.className='tl-fit-swipe-cue-v1__track';
var thumb=document.createElement('span');
thumb.className='tl-fit-swipe-cue-v1__thumb';
track.appendChild(thumb);
var right=document.createElement('span');
right.className='tl-fit-swipe-cue-v1__arrow';
right.textContent='→';
graphic.appendChild(left);
graphic.appendChild(track);
graphic.appendChild(right);
var label=document.createElement('span');
label.className='tl-fit-swipe-cue-v1__label';
label.textContent=swipeLabel;
cue.appendChild(graphic);
cue.appendChild(label);
scroll.parentNode.insertBefore(cue,scroll.nextSibling);
return cue;
}
function initSwipeCues(){
Array.prototype.forEach.call(document.querySelectorAll('#tl-size-fit .tl-fit-table-scroll-v2'),function(scroll){
var cue=createSwipeCue(scroll);
var active=scroll.scrollWidth>scroll.clientWidth+2;
cue.setAttribute('data-active',active?'true':'false');
if(active){
if(scroll.getAttribute('data-tl-fit-scroll-accessible')!=='true'){
scroll.setAttribute('data-tl-fit-scroll-accessible','true');
scroll.setAttribute('tabindex','0');
scroll.setAttribute('aria-label',swipeLabel);
}
if(scroll.getAttribute('data-tl-fit-swipe-bound')!=='true'){
scroll.setAttribute('data-tl-fit-swipe-bound','true');
scroll.addEventListener('scroll',function(){
if(scroll.scrollLeft>6)cue.setAttribute('data-used','true');
},{passive:true});
}
}else if(scroll.getAttribute('data-tl-fit-scroll-accessible')==='true'){
scroll.removeAttribute('data-tl-fit-scroll-accessible');
scroll.removeAttribute('tabindex');
scroll.removeAttribute('aria-label');
}
});
}
function initUx(){if(!refreshLabels())return;initGalleries();initSwipeCues();}
initUx();
document.addEventListener('DOMContentLoaded',initUx);
document.addEventListener('shopify:section:load',initUx);
window.addEventListener('resize',initSwipeCues);
window.setTimeout(initUx,600);
window.setTimeout(initUx,1600);
window.setTimeout(initUx,3400);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tl-manual-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-manual-carousel')) {
 customElements.define('tl-manual-carousel', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   const signal = this.abort.signal;
   const track = this.querySelector('[data-track]');
   const controls = this.querySelector('[data-controls]');
   if (!track || !controls) return;
   const previous = controls.querySelector('[data-prev]');
   const next = controls.querySelector('[data-next]');
   const count = controls.querySelector('[data-count]');
   const update = () => {
    const cards = [...track.children];
    const box = track.getBoundingClientRect();
    const visible = cards.map((card,index) => ({index,box:card.getBoundingClientRect()})).filter(item => item.box.right > box.left + 8 && item.box.left < box.right - 8);
    const max = track.scrollWidth - track.clientWidth;
    controls.hidden = max < 2;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
    if (visible.length) count.textContent = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${cards.length}`;
   };
   const move = direction => {
    const first = track.firstElementChild;
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = first.getBoundingClientRect().width + gap;
    const page = Math.max(1,Math.floor((track.clientWidth + gap)/step));
    track.scrollBy({left:direction*step*page,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   };
   previous.addEventListener('click',()=>move(-1),{signal});
   next.addEventListener('click',()=>move(1),{signal});
   track.addEventListener('scroll',update,{signal,passive:true});
   this.observer?.disconnect();
   this.observer = new ResizeObserver(update);
   this.observer.observe(track);
   update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 });
}
  } catch(e) { console.error(e); }
})();

})();
